import difference from 'lodash/difference';

import {TNewNotification, hideNewNotification, showNewNotification} from '@edna/components';

import {TItemId} from 'src/constants';

import {SystemNotification} from './SystemNotification';
import {WebNotification} from './WebNotification';
import {
  ENotificationLevel,
  ENotificationStatus,
  ESystemNotificationEntityType,
  EWebNotificationType,
  HIDDEN_TYPES,
  TNotificationLevel,
  TNotifications,
  TSystemNews,
  TSystemNotification,
  TWebNotification,
} from './model';

const showWebNotification = (
  notification: TWebNotification,
  changeStatus: (status: TWebNotification['status']) => void,
) => {
  if (
    HIDDEN_TYPES.includes(notification.type) ||
    !Object.keys(EWebNotificationType).includes(notification.type)
  ) {
    return;
  }

  showNewNotification({
    id: notification.id,
    lifeDuration: 'infinity',
    onClose: () => changeStatus(ENotificationStatus.READ),
    message: <WebNotification item={notification} />,
    type: notification.level as TNewNotification['type'],
  });
};

const showSystemNotification = (notification: TSystemNotification) =>
  showNewNotification({
    id: notification.id,
    isPermanent: true,
    message: <SystemNotification item={notification} />,
    type: notification.level as TNewNotification['type'],
  });

const displayedSystemNotificationIds = new Set<TItemId>();

const manageSystemNotifications = (payload: TNotifications) => {
  const systemNotifications =
    payload.systemNotifications?.filter(
      (item): item is TSystemNotification =>
        item.entityType === ESystemNotificationEntityType.NOTIFICATION,
    ) ?? [];

  if (systemNotifications.length) {
    systemNotifications.forEach((notification) => {
      displayedSystemNotificationIds.add(notification.id);
      showSystemNotification(notification);
    });
  }

  const notificationsToHide = difference(
    [...displayedSystemNotificationIds],
    systemNotifications.map((notification) => notification.id),
  );

  notificationsToHide.forEach(hideNewNotification);
};

const newsOrder = Object.values(ENotificationLevel) as unknown as TNotificationLevel;
const sortNews = (news: TSystemNews[]) =>
  [...news].sort((a, b) => newsOrder.indexOf(a.level) - newsOrder.indexOf(b.level));

export {showWebNotification, showSystemNotification, manageSystemNotifications, sortNews};
